module.exports = __webpack_public_path__ + "assets/img/deckmaster-M-gray-lose.fd4bd93d.png";